import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { OccEndpointsService } from "@spartacus/core";

@Injectable({
    providedIn: 'root'
})
export class kbBrakeAppService {
    http = inject(HttpClient);
    occ = inject(OccEndpointsService);
    engReview: boolean = false;

    isNewFormWithExistingValue: boolean = false;
    brakeAppFormFillablegetApi(code?: string) {

        if (code !== null) {
            return this.brakeAppFormEditablegetApi(code);
        } else {
            return this.http.get(this.occ.buildUrl(`brakeapplication/form`));
        }

    }
    brakeAppFormFillablePostApi(payLoad, saveForLater, finalSubmit) {
        return this.http.post(this.occ.buildUrl(`brakeapplication/form?saveForLater=${saveForLater}&finalSubmit=${finalSubmit}`), payLoad);
    }
    sendFileAfterpost(file, code) {
        return this.http.post(this.occ.buildUrl(`brakeapplication/attachment?code=${code}`), file);
    }
    searchBrakeAppGetApi() {
        return this.http.get(this.occ.buildUrl(`brakeapplication/search`));
    }
    searchBrakeAppPostApi(payLoad, currentPage, sortBy) {
        return this.http.post(this.occ.buildUrl(`brakeapplication/search?page=${currentPage}&sort=${sortBy}`), payLoad);
    }
    brakeAppFormEditablegetApi(code) {
        return this.http.get(this.occ.buildUrl(`brakeapplication/formupdate?code=${code}`));
    }
    brakeAppFormEditablePostApi(payLoad, code, saveForLater, finalSubmit) {
        return this.http.post(this.occ.buildUrl(`brakeapplication/formupdate?code=${code}&saveForLater=${saveForLater}&finalSubmit=${finalSubmit}`), payLoad);
    }
    adminbrakeAppSlp(key: string, page: number, sort: string) {
        return this.http.get(this.occ.buildUrl(`brakeapplication/adb-requests?searchTerm=${key}&page=${page}&sort=${sort}`));
    }
    adminBrakeAppExportExcel() {
        return this.http.get(this.occ.buildUrl('brakeapplication/exportBrakeApplications'));
    }
    adminBrakeAppEditpage(code) {
        return this.http.get(this.occ.buildUrl(`brakeapplication/show-request?code=${code}`));
    }
    adminBrakeAppPostApi(payLoad, canSave: boolean) {
        return this.http.post(this.occ.buildUrl(`brakeapplication/save-request?isSave=${canSave}`), payLoad)
    }
    adminBrakeAttachmentPostApi(payLoad, code) {

        return this.http.post(this.occ.buildUrl(`brakeapplication/adminattachment?code=${code}`), payLoad)
    }
    adminRemovefileApi(code) {
        return this.http.post(this.occ.buildUrl(`brakeapplication/delete-attachment?deleteFile=${code}`), null)
    }
}